module.exports = __webpack_public_path__ + "static/media/08_tearsofhair.bb569f47.jpg";